import * as React from 'react'
import * as Debounce from 'react-debounce-input'

interface IDebounceInputProps {
  label?: string
  value: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  debounceWaitTime?: number
  inputWrapperStyle?: object
  labelStyle?: object
  placeholder?: string
  className?: string
}

const DebounceInput: React.FC<IDebounceInputProps> = ({
  label,
  value,
  placeholder,
  onChange,
  debounceWaitTime = 400,
  inputWrapperStyle = {},
  labelStyle = {},
  className,
}: IDebounceInputProps) => {
  return (
    <div className='mr-2' style={inputWrapperStyle}>
      {label && <label style={labelStyle}>{label}</label>}
      <Debounce
        className={`form-control ${className}`}
        debounceTimeout={debounceWaitTime}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
      />
    </div>
  )
}

export { DebounceInput }
